<template>
    <div v-if="isShow" class="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex justify-center items-center z-[100] px-4"
        @click.self="closePopup()">
        
        <!-- Modal Container -->
        <div class="bg-white/95 backdrop-blur-md rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.3)] border border-white/20 w-full max-w-[420px] max-h-[90vh] overflow-hidden flex flex-col"
            :class="{ 'animate-[popupFadeIn_0.3s_cubic-bezier(0.16,1,0.3,1)_forwards]': isVisible, 'animate-[popupFadeOut_0.3s_cubic-bezier(0.16,1,0.3,1)_forwards]': !isVisible }">
            
            <!-- Header -->
            <div class="w-full bg-brand py-3.5 px-5 flex items-center justify-between sticky top-0 z-50 shadow-sm">
                <h2 class="text-yellow-500 font-bold text-[16px] md:text-[18px] tracking-wide flex items-center gap-2">
                    <font-awesome-icon :icon="['fas', 'calendar-check']" />
                    Cập nhật ngày chi
                </h2>
                <button @click="closePopup()"
                    class="w-8 h-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white/90 hover:bg-red-500 hover:text-white hover:border-red-500 hover:shadow-[0_0_15px_rgba(239,68,68,0.5)] transition-all duration-200">
                    <font-awesome-icon :icon="['fas', 'xmark']" class="text-[14px]" />
                </button>
            </div>

            <!-- Body Content -->
            <div class="p-6 flex-1 overflow-y-auto">
                
                <!-- Date Picker Block -->
                <div class="bg-gray-50/50 border border-gray-200 rounded-xl p-4 mb-5 shadow-inner">
                    <label class="block text-[14px] font-semibold text-gray-700 mb-2">Chọn ngày chi mới :</label>
                    <el-date-picker v-model="datePayment" @change="handleDateChange" type="date"
                        placeholder="VD: 15-08-2024" format="dd-MM-yyyy" change-on-select
                        class="!w-full !max-w-none custom-date-picker">
                    </el-date-picker>
                </div>

                <!-- Confirmation Checkbox Block -->
                <label class="flex items-center gap-3 p-3 mb-6 bg-blue-50/30 rounded-xl border border-blue-100 hover:bg-blue-50/60 transition-colors cursor-pointer group">
                   <div class="relative flex items-center justify-center">
                     <input type="checkbox" v-model="checkBoxValue" class="peer appearance-none w-5 h-5 rounded-[5px] border border-gray-300 checked:bg-brand checked:border-brand transition-all cursor-pointer shadow-sm">
                     <font-awesome-icon :icon="['fas', 'check']" class="absolute text-white text-[11px] opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity" />
                   </div>
                   <span class="text-[14px] font-medium text-gray-700 group-hover:text-gray-900 transition-colors">Tôi xác nhận cập nhật thông tin này</span>
                </label>

                <!-- Action Button -->
                <button :disabled="!checkBoxValue"
                    class="w-full relative overflow-hidden group/btn inline-flex items-center justify-center gap-2 px-5 py-[12px]
                           text-[15px] font-bold rounded-xl transition-all duration-300 ease-out shadow-sm
                           disabled:bg-gray-200 disabled:text-gray-400 disabled:shadow-none disabled:cursor-not-allowed
                           bg-brand hover:bg-brand-light text-white hover:shadow-[0_4px_15px_rgba(2,75,179,0.3)] hover:-translate-y-[1px]"
                    @click="updateStatus(propCode)">
                    <font-awesome-icon :icon="['fas', 'floppy-disk']" />
                    <span>Lưu thiết lập</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
export default {
    components: {

    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        propCode: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: 'Today',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: 'Yesterday',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: 'A week ago',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            datePayment: '',
            isVisible: true,
            checkBoxValue: false
        };
    },

    computed: {

    },
    mounted() {

    },
    methods: {
        handleDateChange(value) {
            this.datePayment = this.formatDate(value);
        },

        formatDate(date) {
            if (!date) return null;
            const offset = date.getTimezoneOffset() * 60000; // Chuyển offset thành milliseconds
            return new Date(date - offset).toISOString().split("T")[0]; // Lấy YYYY-MM-DD
        },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed');
            }, 200);
        },
        async updateStatus(id) {
            if (!this.datePayment) {
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Vui lòng chọn ngày chi.'
                });
                return; // Dừng lại nếu chưa chọn ngày chi
            }

            const data = {
                approvePaymentDate: this.datePayment,
                approvePaymentStatus: 1,
                payNow: 0
            };

            await this.$axios.put(`${API_URL}/bills/update/${id}`, {
                type: 'paymentStatus',
                data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                this.$notify.success({
                    title: 'Thành công',
                    message: 'Cập nhật trạng thái thành công.'
                });
                this.closePopup();
                this.$emit('reload');
            }).catch(err => {
                console.log(err);
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi cập nhật trạng thái.'
                });
            });
        }

    }
};
</script>

<style scoped>
@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>